import React from 'react';
import { Box, BoxProps, Flex, Link, Text } from '@chakra-ui/react';
import StyledButton from '../../components/Button/Button';

import { Image } from '@chakra-ui/react';
import { ButtonContainer } from '../MigrationSection/styles';

interface SectionWithPlusTickProps extends BoxProps {
    title?: string;
    subtitle?: string;
    additionalParagraph?: string;
    additionalParagraphMargin?: string;
    boxWidth?: string;
    imageWidth?: string;
    type?: 'default' | 'tick';
    image?: {
        url: string;
        alt: string;
    };
    imageResponsive?: ImageResponsive;
    tickItem: tickItem[];
    background?: string;
    imagePosition?: 'left' | 'right';
    ctaButton?: {
        type?: 'default' | 'outline' | 'outline-reverted' | 'link';
        label: string;
        href: string;
    };
}

interface ImageProperties {
    url: string;
    alt: string;
}

interface ImageResponsive {
    base?: ImageProperties;
    md?: ImageProperties;
}

interface tickItem {
    title: string;
    text?: string;
    notExtended?: boolean;
    link?: {
        url: string;
        name: string;
    };
}

const SectionWithPlusTick: React.FC<SectionWithPlusTickProps> = ({
    title,
    subtitle,
    image,
    tickItem,
    additionalParagraph,
    additionalParagraphMargin,
    type = 'default',
    boxWidth,
    imageWidth,
    background,
    ctaButton,
    imageResponsive,
    imagePosition,
    ...props
}) => {
    return (
        <Box {...props}>
            <Flex flexDirection={'column'}>
                {title && (
                    <Text
                        fontSize="30px"
                        fontWeight={'600'}
                        color={'#171717'}
                        as="b"
                        textAlign="center"
                        marginBottom={'10px'}
                    >
                        {title}
                    </Text>
                )}
                {subtitle && (
                    <Text
                        fontSize="18px"
                        color={'#171717'}
                        fontWeight={'400'}
                        mb="5px"
                        textAlign="center"
                        marginBottom={'60px'}
                    >
                        {subtitle}
                    </Text>
                )}
            </Flex>
            <Flex
                flexDirection={{
                    base: 'column',
                    md: imagePosition === 'right' ? 'row-reverse' : 'row',
                }}
                gap={{ base: 0, md: '30px' }}
                position={'relative'}
                _before={{
                    base: {
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        top: 0,
                        width: '100vw',
                        marginLeft: '50%',
                        left: '-50vw',
                        zIndex: -2,
                        backgroundColor: '#1AAC7A',
                    },
                    lg: {
                        display: 'none',
                    },
                }}
            >
                <Box
                    flex={imageWidth ? `0 0 ${imageWidth}` : ''}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                    width={{ base: imageResponsive ? '100vw' : '', lg: '100%' }}
                >
                    {imageResponsive ? (
                        <picture style={{ objectFit: 'cover' }}>
                            <source
                                height={'100%'}
                                srcSet={imageResponsive.md?.url}
                                media="(min-width: 979px)"
                            />
                            <img height={'270px'} src={imageResponsive.base?.url} alt="Zdjęcie" />
                        </picture>
                    ) : (
                        <Image
                            width={'full'}
                            mx={{
                                sm: 'left',
                                lg: 'initial',
                            }}
                            src={image?.url}
                            alt={image?.alt}
                            objectFit={'cover'}
                            height={{ md: '100%' }}
                        />
                    )}
                </Box>
                <Flex
                    margin={{ base: '0 15px', lg: '0' }}
                    flexDir={'column'}
                    backgroundColor={'#1AAC7A'}
                    justifyItems={'flex-start'}
                    alignItems={'flex-start'}
                    padding={{
                        base: '30px 0',
                        md: '30px',
                        lg: '30px 50px',
                    }}
                    flex={boxWidth ? `0 0 ${boxWidth}` : '0 0 calc(100% / 3 * 2)'}
                    justifyContent={'center'}
                >
                    <Text
                        color={'white'}
                        fontSize={'18px'}
                        lineHeight={'27px'}
                        margin={additionalParagraphMargin ? additionalParagraphMargin : ''}
                    >
                        {additionalParagraph}
                    </Text>
                    {tickItem.map((item, index) => {
                        return (
                            <Flex
                                alignItems={'flex-start'}
                                alignContent={'center'}
                                justifyContent={'flex-start'}
                                key={index}
                                gap={'30px'}
                                my={5}
                                // flex={item.notExtended ? 'unset' : '1'}
                            >
                                {type === 'tick' && (
                                    <Box
                                        w={'20px'}
                                        h={'20px'}
                                        display={'flex'}
                                        alignItems={'center'}
                                        marginTop={'5px'}
                                        css={{
                                            svg: {
                                                maxWidth: 'max-content',
                                            },
                                        }}
                                    >
                                        <svg
                                            style={{ marginTop: '5px' }}
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M11.058 13.6929L11.0655 13.7004L8.94418 15.8217L3.68945 10.567L5.81077 8.44569L8.9367 11.5716L16.5083 4L18.6296 6.12132L11.058 13.6929Z"
                                                fill="#171717"
                                            />
                                        </svg>
                                    </Box>
                                )}
                                {type === 'default' && (
                                    <Image
                                        src={
                                            'https://www.idosell.com/panel/file-gate.php?id=298410&ext=.png'
                                        }
                                        alt={'Plus tick'}
                                        width={'20px'}
                                        height={'20px'}
                                        marginTop={'5px'}
                                    />
                                )}

                                <Flex flex={'1'} flexDirection={'column'} gap={'5px'}>
                                    <Text
                                        fontWeight={'600'}
                                        fontSize={'21px'}
                                        color={'white'}
                                        w={'full'}
                                    >
                                        {item.title}
                                    </Text>
                                    {item.text && (
                                        <Text
                                            paddingBottom={'10px'}
                                            fontSize={'16px'}
                                            color={'#171717'}
                                            lineHeight={'25px'}
                                        >
                                            {item.text}
                                        </Text>
                                    )}
                                    {item.link && (
                                        <Link
                                            href={item.link.url}
                                            fontSize={'16px'}
                                            color={'#171717'}
                                            fontWeight={'600'}
                                            lineHeight={'18px'}
                                            textDecoration={'underline'}
                                            _hover={{
                                                textDecoration: 'none',
                                            }}
                                        >
                                            {item.link.name}
                                        </Link>
                                    )}
                                </Flex>
                            </Flex>
                        );
                    })}
                    {ctaButton && !ctaButton.type && (
                        <Link
                            href={ctaButton.href}
                            target="_blank"
                            background={'#171717'}
                            color={'white'}
                            padding={'12px 30px'}
                            fontSize={'16px'}
                            fontWeight={'600'}
                            display={'flex'}
                            alignItems={'center'}
                            gap={'10px'}
                            mt="30px"
                            _hover={{
                                underline: 'none',
                                background: 'rgba(11, 113, 83, 0.5)',
                            }}
                        >
                            {ctaButton.label}
                            <svg
                                width="9"
                                height="14"
                                viewBox="0 0 9 14"
                                fill="white"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                            </svg>
                        </Link>
                    )}
                    {ctaButton && (ctaButton.type || ctaButton.type === 'link') && (
                        <Link
                            fontSize={'16px'}
                            textDecoration={'underline'}
                            fontWeight={'600'}
                            color={'#171717'}
                            _hover={{ textDecoration: 'none' }}
                            target="_blank"
                            href={ctaButton.href}
                        >
                            {ctaButton.label}
                        </Link>
                    )}
                </Flex>
            </Flex>
        </Box>
    );
};

export default SectionWithPlusTick;
